// extracted by mini-css-extract-plugin
export default {"buttonBaseStyle":"IsDeletedColumn_buttonBaseStyle__iCKH9","errorModal":"IsDeletedColumn_errorModal__2I5tJ"};